import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'หน้าแรก', href: '#home' },
    { name: 'บริการของเรา', href: '#services' },
    { name: 'ผลิตภัณฑ์', href: '#products' },
    { name: 'พันธมิตร', href: '#partners' },
    { name: 'ติดต่อเรา', href: '#contact' },
  ];

  const services = [
    'Security Solutions',
    'Energy Solutions',
    'Network & Internet',
    'Software & Application',
    'IPTV & Digital Signage',
  ];

  const socialLinks = [
    { name: 'Facebook', icon: '📘', href: '#' },
    { name: 'Line', icon: '💬', href: '#' },
    { name: 'YouTube', icon: '📺', href: '#' },
    { name: 'LinkedIn', icon: '💼', href: '#' },
  ];

  return (
    <footer className="bg-gradient-to-r from-napa-blue-800 to-napa-blue-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-3">
                <span className="text-napa-blue-800 font-bold text-xl">N</span>
              </div>
              <span className="text-xl font-bold">Napa Corporation</span>
            </div>
            <p className="text-blue-100 mb-4 text-sm leading-relaxed">
              ให้บริการโซลูชันครบวงจรสำหรับงานราชการ โรงแรม โรงงาน สถานศึกษา 
              และองค์กรต่างๆ ด้วยเทคโนโลยีที่ทันสมัยและทีมงานมืออาชีพ
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors duration-200"
                  title={social.name}
                >
                  <span className="text-lg">{social.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">ลิงก์ด่วน</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-blue-100 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">บริการของเรา</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-blue-100 text-sm">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">ติดต่อเรา</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start">
                <span className="text-blue-200 mr-2">📍</span>
                <span className="text-blue-100">
                  Napa Corporation<br />
                  Solutions & Services<br />
                  กรุงเทพมหานคร, ประเทศไทย
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-blue-200 mr-2">📞</span>
                <span className="text-blue-100">+66 XX-XXX-XXXX</span>
              </div>
              <div className="flex items-center">
                <span className="text-blue-200 mr-2">✉️</span>
                <span className="text-blue-100">info@napacorporation.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-blue-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-blue-100 text-sm mb-4 md:mb-0">
              © {currentYear} Napa Corporation. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-blue-100 hover:text-white transition-colors duration-200">
                นโยบายความเป็นส่วนตัว
              </a>
              <a href="#" className="text-blue-100 hover:text-white transition-colors duration-200">
                เงื่อนไขการใช้งาน
              </a>
              <a href="#" className="text-blue-100 hover:text-white transition-colors duration-200">
                แผนที่เว็บไซต์
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
